module.exports = __webpack_public_path__ + "static/7-874b8e7bc7e8d1507b50f56bc6c9b536.woff";